module.exports = __webpack_public_path__ + "assets/img/text-benefit-01.7d1f48f5.svg";